import {
  ContentType,
  EAccountType,
  EKeyPartner,
  EPackageType,
  EPlaylistSourceType,
  IBaseList,
  TextToSpeechSpeed,
} from 'src/types';
import { EPaymentMethod } from 'src/types/payment.type';

export default class OPTIONS {
  static cloudTypeopts: IBaseList<ContentType>[] = [
    { label: 'Thư mục', value: ContentType.FOLDER },
    { label: 'Tệp tin', value: ContentType.FILE },
    { label: 'Đường dẫn tiếp sóng', value: ContentType.LINK },
    { label: 'Danh sách phát', value: ContentType.LIST },
    { label: 'Văn bản chuyển đổi', value: ContentType.TTS },
  ];

  static partnerTtsOpts: IBaseList<EKeyPartner>[] = [
    { label: 'Viettel', value: EKeyPartner.VIETTEL },
    { label: 'FPT', value: EKeyPartner.FPT },
    { label: 'Vbee', value: EKeyPartner.VBEE },
    { label: 'Free', value: EKeyPartner.FREE },
  ];

  static viettelVoiceOpts: IBaseList[] = [
    { label: 'Quỳnh Anh (Nữ miền Bắc)', value: 'hn-quynhanh' },
    { label: 'Diễm My (Nữ miền Nam)', value: 'hcm-diemmy' },
    { label: 'Mai Ngọc (Nữ miền Trung)', value: 'hue-maingoc' },
    { label: 'Phương Trang (Nữ miền Bắc)', value: 'hn-phuongtrang' },
    { label: 'Thảo Chi (Nữ miền Bắc)', value: 'hn-thaochi' },
    { label: 'Thanh Hà (Nữ miền Bắc)', value: 'hn-thanhha' },
    { label: 'Phương Ly (Nữ miền Nam)', value: 'hcm-phuongly' },
    { label: 'Thùy Dung (Nữ miền Nam)', value: 'hcm-thuydung' },
    { label: 'Thanh Tùng (Nam miền Bắc)', value: 'hn-thanhtung' },
    { label: 'Bảo Quốc (Nam miền Trung)', value: 'hue-baoquoc' },
    { label: 'Minh Quân (Nam miền Nam)', value: 'hcm-minhquan' },
    { label: 'Thanh Phương (Nữ miền Bắc)', value: 'hn-thanhphuong' },
    { label: 'Nam Khánh (Nam miền Bắc)', value: 'hn-namkhanh' },
    { label: 'Lê Yến (Nữ miền Nam)', value: 'hn-leyen' },
    { label: 'Tiến Quân (Nam miền Bắc)', value: 'hn-tienquan' },
    { label: 'Thùy Duyên (Nữ miền Nam)', value: 'hcm-thuyduyen' },
  ];

  static fptVoiceOpts: IBaseList[] = [
    { label: 'Ban Mai (Nữ miền Bắc)', value: 'banmai' },
    { label: 'Lan Nhi (Nữ miền Nam)', value: 'lannhi' },
    { label: 'Lê Minh (Nam miền Bắc)', value: 'leminh' },
    { label: 'Mỹ An (Nữ miền Trung)', value: 'myan' },
    { label: 'Thu Minh (Nữ miền Bắc)', value: 'thuminh' },
    { label: 'Gia Huy (Nam miền Trung)', value: 'giahuy' },
    { label: 'Linh San (Nữ miền Nam)', value: 'linhsan' },
  ];

  static vbeeVoiceOpts: IBaseList[] = [
    { label: 'HN - Ngọc Huyền', value: 'hn_female_ngochuyen_full_48k-fhg' },
    { label: 'HN - Anh Khôi', value: 'hn_male_phuthang_news65dt_44k-fhg' },
    { label: 'HN - Mạnh Dũng', value: 'hn_male_manhdung_news_48k-fhg' },
    { label: 'HN - Thanh Long', value: 'hn_male_thanhlong_talk_48k-fhg' },
    { label: 'HN - Mai Phương', value: 'hn_female_maiphuong_vdts_48k-fhg' },
    { label: 'SG - Tường Vy', value: 'sg_female_tuongvy_call_44k-fhg' },
    { label: 'SG - Lan Trinh', value: 'sg_female_lantrinh_vdts_48k-fhg' },
    { label: 'SG - Trung Kiên', value: 'sg_male_trungkien_vdts_48k-fhg' },
    { label: 'SG - Minh Hoàng', value: 'sg_male_minhhoang_full_48k-fhg' },
    { label: 'SG - Thảo Trinh', value: 'sg_female_thaotrinh_full_48k-fhg' },
    { label: 'Huế - Duy Phương', value: 'hue_male_duyphuong_full_48k-fhg' },
    { label: 'Huế - Hương Giang', value: 'hue_female_huonggiang_full_48k-fhg' },
  ];

  static typeConfigTtsOpts: IBaseList<number>[] = [
    { label: 'Có sẵn', value: 1 },
    { label: 'Tự nhập', value: 2 },
  ];

  static speedTtsOpts: IBaseList<TextToSpeechSpeed>[] = [
    { label: 'Rất chậm', value: TextToSpeechSpeed.VERY_SLOW },
    { label: 'Chậm', value: TextToSpeechSpeed.SLOW },
    { label: 'Bình thường', value: TextToSpeechSpeed.BALANCE },
    { label: 'Nhanh', value: TextToSpeechSpeed.FAST },
    { label: 'Rất nhanh', value: TextToSpeechSpeed.VERY_FAST },
  ];

  static playlistPriorityOpts: IBaseList<number>[] = [
    { label: 'Thông thường', value: 0 },
    { label: 'Ưu tiên', value: 1 },
    { label: 'Khẩn cấp', value: 2 },
  ];

  static playlistTypeOtps: IBaseList<string>[] = [
    { value: 'ONCE', label: 'Không lặp lại' },
    { value: 'BY_DATE', label: 'Hàng ngày' },
    { value: 'BY_WEEK', label: 'Hàng tuần' },
    { value: 'BY_MONTH', label: 'Hàng tháng' },
  ];

  static playlistSourceTypeOtps: IBaseList<EPlaylistSourceType>[] = [
    { label: 'Nội dung', value: EPlaylistSourceType.LIST },
    { label: 'Tệp tin', value: EPlaylistSourceType.FILE },
    { label: 'Đường dẫn tiếp sóng', value: EPlaylistSourceType.URL },
    { label: 'Văn bản chuyển đổi', value: EPlaylistSourceType.TEXT_TO_SPEECH },
  ];

  static playlistModeOtps: IBaseList<string>[] = [
    { value: 'ONCE', label: 'Khung giờ cố định' },
    { value: 'SCHEDULED', label: 'Theo lịch phát đã thiết lập' },
    { value: 'INSTANT', label: 'Khẩn cấp, phát ngay' },
  ];

  static deviceTypeOpts: IBaseList<string>[] = [
    {
      value: 'RECEIVER',
      label: 'Bộ thu',
    },
    {
      value: 'MICRO',
      label: 'Micro',
    },
    {
      value: 'INTEGRATION',
      label: 'Bộ tích hợp tự động',
    },
  ];

  // Trạng thái kết nối thiết bị
  static deviceConnectStatusOpts: IBaseList<number>[] = [
    { value: 1, label: 'Đang kết nối' },
    { value: 0, label: 'Không kết nối' },
  ];

  // Trạng thái kết nối thiết bị
  static deviceStatusOpts: IBaseList<number>[] = [
    {
      value: 0,
      label: 'Không phát sóng',
    },
    {
      value: 1,
      label: 'Đang phát sóng',
    },
    {
      value: 2,
      label: 'Tạm dừng phát sóng',
    },
    {
      value: 3,
      label: 'Mất kết nối',
    },
  ];

  static dayOfWeekOpts: IBaseList<number>[] = [
    {
      value: 1,
      label: 'Thứ 2',
    },
    {
      value: 2,
      label: 'Thứ 3',
    },
    {
      value: 3,
      label: 'Thứ 4',
    },
    {
      value: 4,
      label: 'Thứ 5',
    },
    {
      value: 5,
      label: 'Thứ 6',
    },
    {
      value: 6,
      label: 'Thứ 7',
    },
    {
      value: 0,
      label: 'Chủ nhật',
    },
  ];

  static dayOfMonthOpts: IBaseList<number>[] = [
    {
      value: 1,
      label: 'Ngày 1',
    },
    {
      value: 2,
      label: 'Ngày 2',
    },
    {
      value: 3,
      label: 'Ngày 3',
    },
    {
      value: 4,
      label: 'Ngày 4',
    },
    {
      value: 5,
      label: 'Ngày 5',
    },
    {
      value: 6,
      label: 'Ngày 6',
    },
    {
      value: 7,
      label: 'Ngày 7',
    },
    {
      value: 8,
      label: 'Ngày 8',
    },
    {
      value: 9,
      label: 'Ngày 9',
    },
    {
      value: 10,
      label: 'Ngày 10',
    },
    {
      value: 11,
      label: 'Ngày 11',
    },
    {
      value: 12,
      label: 'Ngày 12',
    },
    {
      value: 13,
      label: 'Ngày 13',
    },
    {
      value: 14,
      label: 'Ngày 14',
    },
    {
      value: 15,
      label: 'Ngày 15',
    },
    {
      value: 16,
      label: 'Ngày 16',
    },
    {
      value: 17,
      label: 'Ngày 17',
    },
    {
      value: 18,
      label: 'Ngày 18',
    },
    {
      value: 19,
      label: 'Ngày 19',
    },
    {
      value: 20,
      label: 'Ngày 20',
    },
    {
      value: 21,
      label: 'Ngày 21',
    },
    {
      value: 22,
      label: 'Ngày 22',
    },
    {
      value: 23,
      label: 'Ngày 23',
    },
    {
      value: 24,
      label: 'Ngày 24',
    },
    {
      value: 25,
      label: 'Ngày 25',
    },
    {
      value: 26,
      label: 'Ngày 26',
    },
    {
      value: 27,
      label: 'Ngày 27',
    },
    {
      value: 28,
      label: 'Ngày 28',
    },
    {
      value: 29,
      label: 'Ngày 29',
    },
    {
      value: 30,
      label: 'Ngày 30',
    },
    {
      value: 31,
      label: 'Ngày 31',
    },
  ];

  static paymentMethodOpts: IBaseList<EPaymentMethod>[] = [
    { value: EPaymentMethod.TRANSFER, label: 'Chuyển khoản' },
    { value: EPaymentMethod.COD, label: 'Tiền mặt' },
  ];

  static paymentStatusOpts: IBaseList<number>[] = [
    { value: 1, label: 'Đợi xác thực' },
    { value: 2, label: 'Hoàn thành' },
    { value: 3, label: 'Đã hủy' },
  ];

  static typeAccountOpts: IBaseList<EAccountType>[] = [
    { value: EAccountType.ADMIN, label: 'Thông thường' },
    { value: EAccountType.PARTNER, label: 'Đối tác' },
  ];

  static typePackageOpts: IBaseList<EPackageType>[] = [
    { value: EPackageType.d, label: 'Ngày' },
    { value: EPackageType.m, label: 'Tháng' },
    { value: EPackageType.y, label: 'Năm' },
    { value: EPackageType.i, label: 'Vĩnh viễn' },
  ];
}
